const DATE_FORMATTER = new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
});

const DAY_MONTH_FORMATTER = new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "short",
});

const MONTH_YEAR_FORMATTER = new Intl.DateTimeFormat("en-GB", {
    month: "short",
    year: "numeric",
});

export const NETWORKING_EVENTS = [
    {
        id: "pr-asia-indonesia-2026",
        priority: "A",
        market: "Jakarta",
        title: "PR Asia Indonesia 2026",
        start: "2026-07-15",
        end: "2026-07-15",
        location: "Jakarta",
        category: "PR, communications, media, AI",
        organiser: "MARKETING-INTERACTIVE",
        bestFor: "Comms, Media, Strategy, Client Service",
        why: "Communications, PR, reputation, media, AI-shaped discovery, and senior brand-side communications leaders.",
        registrationUrl: "https://conferences.marketing-interactive.com/pr-asia-id/",
        type: "Industry body / publisher",
    },
    {
        id: "marketing-events-awards-hk-2026",
        priority: "A",
        market: "Hong Kong",
        title: "Marketing Events Awards Hong Kong 2026",
        start: "2026-07-16",
        end: "2026-07-16",
        location: "Hong Kong",
        category: "Events, activation, experiential, agency",
        organiser: "MARKETING-INTERACTIVE",
        bestFor: "Experience, Creative, Strategy, Client Service",
        why: "Strong brand experience, activation, event, experiential, and agency networking opportunity.",
        registrationUrl: "https://awards.marketing-interactive.com/mevents-hk/",
        type: "Industry body / publisher",
    },
    {
        id: "agency-of-the-year-markies-malaysia-2026",
        priority: "A",
        market: "Malaysia",
        title: "Agency of the Year and MARKies Awards Malaysia 2026",
        start: "2026-07-16",
        end: "2026-07-16",
        location: "Malaysia",
        category: "Agency, marketing, awards",
        organiser: "MARKETING-INTERACTIVE",
        bestFor: "Malaysia leadership, Creative, Strategy, Client Service",
        why: "Malaysia agency and marketing industry gala with senior agency, brand, and partner attendance.",
        registrationUrl: "https://awards.marketing-interactive.com/agency-of-the-year-my/",
        type: "Industry body / publisher",
    },
    {
        id: "bangkok-international-content-market-2026",
        priority: "B",
        market: "Bangkok",
        title: "Bangkok International Content Market 2026",
        start: "2026-07-20",
        end: "2026-07-22",
        location: "Bangkok",
        category: "Media, content, entertainment, production",
        organiser: "BICM / Content industry",
        bestFor: "Media, Content, Creative, Partnerships",
        why: "Media, entertainment, content, production, and distribution networking for Thailand and regional content partners.",
        registrationUrl: "https://www.contentasia.tv/events",
        type: "Publisher / media",
    },
    {
        id: "agency-of-the-year-singapore-2026",
        priority: "A",
        market: "Singapore",
        title: "Agency of the Year Awards Singapore 2026",
        start: "2026-07-24",
        end: "2026-07-24",
        location: "Singapore",
        category: "Agency, marketing, awards",
        organiser: "MARKETING-INTERACTIVE",
        bestFor: "Singapore leadership, Creative, Strategy, Client Service",
        why: "One of the clearest Singapore agency networking nights; useful for senior agency and client-side connections.",
        registrationUrl: "https://awards.marketing-interactive.com/agency-of-the-year-sg/",
        type: "Industry body / publisher",
    },
    {
        id: "whats-next-marketing-singapore-2026",
        priority: "A",
        market: "Singapore",
        title: "What's NEXT in Marketing: Singapore 2026",
        start: "2026-07-29",
        end: "2026-07-29",
        location: "One Farrer Hotel, Singapore",
        category: "Marketing, digital, AI, ecommerce, CX",
        organiser: "MARKETECH APAC",
        bestFor: "Digital, Performance, Media, Strategy",
        why: "Singapore-specific marketing event with AI, ecommerce, digital advertising, customer experience, and senior brand speakers.",
        registrationUrl: "https://marketech-apac.com/conference/whats-next-in-marketing-singapore-2026/",
        type: "Marketing / digital",
    },
    {
        id: "pr-asia-singapore-2026",
        priority: "A",
        market: "Singapore",
        title: "PR Asia Singapore 2026",
        start: "2026-08-04",
        end: "2026-08-04",
        location: "Singapore",
        category: "PR, communications, media, AI",
        organiser: "MARKETING-INTERACTIVE",
        bestFor: "Comms, Media, Strategy, Client Service",
        why: "Flagship communications conference covering AI, media ecosystems, trust, and cultural intelligence.",
        registrationUrl: "https://conferences.marketing-interactive.com/pr-asia-sg/",
        type: "Industry body / publisher",
    },
    {
        id: "digital-transformation-indonesia-2026",
        priority: "B",
        market: "Jakarta",
        title: "Digital Transformation Indonesia Conference & Expo 2026",
        start: "2026-08-05",
        end: "2026-08-06",
        location: "Hall A & B, JICC Senayan, Jakarta",
        category: "Digital transformation, AI, enterprise tech",
        organiser: "Digital Transformation Indonesia",
        bestFor: "Technology, Digital, Data, Client Service",
        why: "Large enterprise technology event with digital solution providers, decision makers, and business matching.",
        registrationUrl: "https://digitaltransformation.co.id/",
        type: "Technology / AI",
    },
    {
        id: "apmf-2026",
        priority: "A",
        market: "Bali",
        title: "APMF 2026: Blueprint the Beyond",
        start: "2026-08-05",
        end: "2026-08-07",
        location: "BNDCC, Bali",
        category: "Media, advertising, agency, marketing, AI",
        organiser: "APMF",
        bestFor: "Media, Creative, Strategy, Client Service, Indonesia leadership",
        why: "One of the strongest regional advertising/media events for agency and brand decision makers.",
        registrationUrl: "https://apmf.com/",
        type: "Media / advertising",
    },
    {
        id: "pr-asia-malaysia-2026",
        priority: "A",
        market: "Malaysia",
        title: "PR Asia Malaysia 2026",
        start: "2026-08-12",
        end: "2026-08-12",
        location: "Kuala Lumpur",
        category: "PR, communications, media, AI",
        organiser: "MARKETING-INTERACTIVE",
        bestFor: "Comms, Media, Strategy, Client Service",
        why: "Kuala Lumpur communications and PR conference with brand-side and communications leaders.",
        registrationUrl: "https://conferences.marketing-interactive.com/pr-asia-my/",
        type: "Industry body / publisher",
    },
    {
        id: "intrigue-madverse-jakarta-2026",
        priority: "A",
        market: "Jakarta",
        title: "Intrigue MAdVerse Jakarta 2026",
        start: "2026-08-19",
        end: "2026-08-19",
        location: "Jakarta",
        category: "AI marketing, martech, agency, digital",
        organiser: "Intrigue",
        bestFor: "Indonesia leadership, Digital, Performance, Client Service",
        why: "AI-powered marketing and martech summit for CMOs, marketers, and agencies.",
        registrationUrl: "https://www.intriguesummit.com/madverse2026jakarta",
        type: "Marketing / digital",
    },
    {
        id: "coinfest-asia-2026",
        priority: "C",
        market: "Bali",
        title: "Coinfest Asia 2026",
        start: "2026-08-20",
        end: "2026-08-21",
        location: "Melasti Beach, Bali",
        category: "Web3, fintech, crypto, digital community",
        organiser: "Coinfest Asia",
        bestFor: "Innovation, Digital, Business Development",
        why: "Niche but useful if targeting Web3, fintech, startup, or digital-native clients.",
        registrationUrl: "https://coinfest.asia/",
        type: "Technology / AI",
    },
    {
        id: "digimarcon-singapore-2026",
        priority: "A",
        market: "Singapore",
        title: "DigiMarCon Singapore 2026",
        start: "2026-08-26",
        end: "2026-08-27",
        location: "Four Points by Sheraton Singapore Riverview",
        category: "Digital marketing, media, advertising, adtech, martech, AI",
        organiser: "DigiMarCon",
        bestFor: "Digital, Media, Performance, Strategy",
        why: "Direct fit for digital marketing, media, advertising, adtech, martech, SaaS, AI, and lead generation.",
        registrationUrl: "https://digimarconsingapore.sg/",
        type: "Marketing / digital",
    },
    {
        id: "whats-next-marketing-indonesia-2026",
        priority: "A",
        market: "Jakarta",
        title: "What's NEXT in Marketing: Indonesia 2026",
        start: "2026-08-26",
        end: "2026-08-26",
        location: "Pullman Jakarta Central Park",
        category: "Marketing, AI, performance, influencer, digital",
        organiser: "MARKETECH APAC",
        bestFor: "Indonesia leadership, Digital, Media, Performance",
        why: "Indonesia-specific marketing event covering AI, data, customer experience, influencer marketing, digital advertising, and performance.",
        registrationUrl: "https://marketech-apac.com/conference/whats-next-in-marketing-indonesia-2026/",
        type: "Marketing / digital",
    },
    {
        id: "aibp-indonesia-2026",
        priority: "B",
        market: "Jakarta",
        title: "AIBP Conference & Exhibition Indonesia 2026",
        start: "2026-08-26",
        end: "2026-08-27",
        location: "Jakarta",
        category: "Enterprise innovation, AI, digital transformation",
        organiser: "AIBP",
        bestFor: "Technology, Digital, Business Development",
        why: "Curated enterprise and government audience; useful for technology-led client relationships.",
        registrationUrl: "https://www.aibp.sg/conference-exhibition-indonesia",
        type: "Technology / AI",
    },
    {
        id: "techsauce-global-summit-2026",
        priority: "A",
        market: "Bangkok",
        title: "Techsauce Global Summit 2026",
        start: "2026-08-26",
        end: "2026-08-28",
        location: "Queen Sirikit National Convention Center, Bangkok",
        category: "AI, tech, startups, digital business",
        organiser: "Techsauce",
        bestFor: "Digital, Technology, Innovation, Business Development",
        why: "Major Southeast Asia tech and business summit with AI, fintech, transformation, and startup audiences.",
        registrationUrl: "https://summit.techsauce.co/",
        type: "Technology / AI",
    },
    {
        id: "festival-of-marketing-asia-2026",
        priority: "A",
        market: "Kuala Lumpur",
        title: "Festival of Marketing Asia 2026",
        start: "2026-09-03",
        end: "2026-09-03",
        location: "Kuala Lumpur",
        category: "Marketing, agency, media, brand",
        organiser: "Campaign Asia",
        bestFor: "Marketing, Strategy, Client Service, Business Development",
        why: "Broad marketing ecosystem event for modern marketers, brands, agencies, and partners.",
        registrationUrl: "https://www.campaignasia.com/events",
        type: "Industry body / publisher",
    },
    {
        id: "mob-ex-awards-singapore-2026",
        priority: "B",
        market: "Singapore",
        title: "Mob-Ex Awards Singapore 2026",
        start: "2026-09-03",
        end: "2026-09-03",
        location: "Singapore",
        category: "Mobile marketing, digital, CRM, commerce",
        organiser: "MARKETING-INTERACTIVE",
        bestFor: "Digital, Media, Performance, CRM",
        why: "Mobile marketing and digital customer-engagement awards; useful for media, performance, CRM, app, and commerce relationships.",
        registrationUrl: "https://awards.marketing-interactive.com/mobex-awards-sg/",
        type: "Industry body / publisher",
    },
    {
        id: "avia-dialogue-jakarta-2026",
        priority: "B",
        market: "Jakarta",
        title: "AVIA Dialogue - Jakarta 2026",
        start: "2026-09-08",
        end: "2026-09-08",
        location: "Jakarta",
        category: "Media, video, streaming, content",
        organiser: "Asia Video Industry Association",
        bestFor: "Media, Content, Partnerships, Technology",
        why: "Media, video, streaming, content, and broadcaster networking in Indonesia.",
        registrationUrl: "https://avia.org/events/",
        type: "Publisher / media",
    },
    {
        id: "pr-asia-philippines-2026",
        priority: "A",
        market: "Manila",
        title: "PR Asia Philippines 2026",
        start: "2026-09-09",
        end: "2026-09-09",
        location: "Manila",
        category: "PR, communications, media, AI",
        organiser: "MARKETING-INTERACTIVE",
        bestFor: "Comms, Media, Strategy, Client Service",
        why: "Manila communications conference focused on misinformation, community engagement, credibility, and business impact.",
        registrationUrl: "https://conferences.marketing-interactive.com/pr-asia-ph/",
        type: "Industry body / publisher",
    },
    {
        id: "marketing-excellence-thailand-2026",
        priority: "B",
        market: "Bangkok",
        title: "Marketing Excellence Awards Thailand 2026",
        start: "2026-09-11",
        end: "2026-09-11",
        location: "Thailand",
        category: "Marketing, agency, awards",
        organiser: "MARKETING-INTERACTIVE",
        bestFor: "Thailand leadership, Creative, Strategy, Client Service",
        why: "Awards gala for Thai marketers and agencies; useful networking if we are developing Bangkok relationships.",
        registrationUrl: "https://awards.marketing-interactive.com/marketing-excellence-th/why-attend/",
        type: "Industry body / publisher",
    },
    {
        id: "digital-marketing-asia-singapore-2026",
        priority: "A",
        market: "Singapore",
        title: "Digital Marketing Asia Singapore 2026",
        start: "2026-09-22",
        end: "2026-09-23",
        location: "Shangri-La Singapore",
        category: "Digital marketing, AI, performance, data, commerce",
        organiser: "MARKETING-INTERACTIVE",
        bestFor: "Digital, Media, Performance, Strategy, Client Service",
        why: "Regional marketing decision-maker event with senior marketing and digital leaders.",
        registrationUrl: "https://conferences.marketing-interactive.com/digital-marketing-asia/",
        type: "Marketing / digital",
    },
    {
        id: "whats-next-marketing-thailand-2026",
        priority: "A",
        market: "Bangkok",
        title: "What's NEXT in Marketing: Thailand 2026",
        start: "2026-09-23",
        end: "2026-09-23",
        location: "Bangkok",
        category: "Marketing, AI, performance, digital advertising, social commerce",
        organiser: "MARKETECH APAC",
        bestFor: "Bangkok leadership, Digital, Performance, Media",
        why: "Thailand-specific marketing event with AI, digital advertising, social commerce, and roundtable networking.",
        registrationUrl: "https://marketech-apac.com/conference/whats-next-in-marketing-thailand-2026/",
        type: "Marketing / digital",
    },
    {
        id: "campaign-connect-indonesia-2026",
        priority: "A",
        market: "Jakarta",
        title: "Campaign Connect Indonesia 2026",
        start: "2026-09-23",
        end: "2026-09-23",
        location: "Jakarta",
        category: "Marketing, brand, business leadership",
        organiser: "Campaign Asia",
        bestFor: "Indonesia leadership, Strategy, Client Service, Business Development",
        why: "Senior marketer and business leader event in Indonesia, useful for brand and growth relationships.",
        registrationUrl: "https://www.campaignasia.com/events",
        type: "Industry body / publisher",
    },
    {
        id: "intrigue-madverse-kuala-lumpur-2026",
        priority: "A",
        market: "Malaysia",
        title: "Intrigue MAdVerse Kuala Lumpur 2026",
        start: "2026-09-24",
        end: "2026-09-24",
        location: "Kuala Lumpur",
        category: "AI marketing, martech, agency, digital",
        organiser: "Intrigue",
        bestFor: "Malaysia leadership, Digital, Performance, Strategy",
        why: "AI-powered marketing and martech summit for CMOs, marketers, and agencies.",
        registrationUrl: "https://www.intriguesummit.com/madverse2026kualalumpur",
        type: "Marketing / digital",
    },
    {
        id: "apac-effie-awards-gala-2026",
        priority: "B",
        market: "Singapore",
        title: "APAC Effie Awards Gala 2026",
        start: "2026-09-25",
        end: "2026-09-25",
        location: "Singapore",
        category: "Marketing effectiveness, awards",
        organiser: "Effie Asia Pacific",
        bestFor: "Strategy, Client Service, Brand, Business Development",
        why: "Effectiveness-focused marketing awards; good for senior marketers and brand strategy contacts.",
        registrationUrl: "https://www.apaceffie.com/home",
        type: "Industry body / publisher",
    },
    {
        id: "digital-marketing-asia-philippines-2026",
        priority: "A",
        market: "Manila",
        title: "Digital Marketing Asia Philippines 2026",
        start: "2026-09-29",
        end: "2026-09-29",
        location: "Manila",
        category: "Digital marketing, AI, commerce, data",
        organiser: "MARKETING-INTERACTIVE",
        bestFor: "Philippines leadership, Digital, Media, Performance",
        why: "Senior marketer event with AI, commerce, data, and marketing transformation topics.",
        registrationUrl: "https://conferences.marketing-interactive.com/digital-marketing-ph/",
        type: "Marketing / digital",
    },
    {
        id: "retail-asia-summit-singapore-2026",
        priority: "B",
        market: "Singapore",
        title: "Retail Asia Summit Singapore 2026",
        start: "2026-09-29",
        end: "2026-09-29",
        location: "Grand Copthorne Waterfront Hotel Singapore",
        category: "Retail, responsible AI, unified data, customer experience",
        organiser: "Retail Asia",
        bestFor: "Commerce, Digital, Strategy, Client Service",
        why: "Retail executives, brand leaders, and digital innovators focused on responsible AI, unified data, and experience innovation.",
        registrationUrl: "https://retailasia.com/event/retail-asia-summit-singapore-september-29-2026",
        type: "Marketing / digital",
    },
    {
        id: "tech-week-singapore-2026",
        priority: "B",
        market: "Singapore",
        title: "Tech Week Singapore 2026",
        start: "2026-09-29",
        end: "2026-09-30",
        location: "Sands Expo Convention Centre, Singapore",
        category: "AI, big data, cloud, enterprise technology",
        organiser: "Tech Week Singapore",
        bestFor: "Technology, Digital, Data, Business Development",
        why: "Large regional technology event with cloud, AI, big data, cybersecurity, and enterprise decision makers.",
        registrationUrl: "https://www.singaporetechnologyweek.com/",
        type: "Technology / AI",
    },
    {
        id: "imedia-retail-summit-sea-2026",
        priority: "B",
        market: "Malaysia",
        title: "iMedia Retail Summit Southeast Asia 2026",
        start: "2026-09-30",
        end: "2026-10-02",
        location: "Angsana Teluk Bahang, Penang",
        category: "Retail, ecommerce, digital marketing, media",
        organiser: "iMedia",
        bestFor: "Commerce, Media, Digital, Client Service",
        why: "Invite-led retail and digital leaders forum; useful for commerce and media opportunities.",
        registrationUrl: "https://www.imediasummits.com/retailsea",
        type: "Marketing / digital",
    },
    {
        id: "asocio-digital-ai-summit-indonesia-2026",
        priority: "B",
        market: "Jakarta",
        title: "ASOCIO Digital & AI Summit Indonesia 2026",
        start: "2026-10-05",
        end: "2026-10-07",
        location: "Swissotel Jakarta PIK Avenue",
        category: "AI, digital transformation, policy, innovation",
        organiser: "ASOCIO",
        bestFor: "Technology, Digital, Business Development",
        why: "Strong AI and digital leadership event across Asia-Oceania, useful for enterprise and government-adjacent leads.",
        registrationUrl: "https://asocio.aptiknas.org/",
        type: "Technology / AI",
    },
    {
        id: "martech-summit-bangkok-2026",
        priority: "A",
        market: "Bangkok",
        title: "The MarTech Summit Bangkok 2026",
        start: "2026-10-06",
        end: "2026-10-06",
        location: "Hotel Nikko Bangkok",
        category: "Martech, CX, CRM, AI, digital transformation",
        organiser: "The MarTech Summit",
        bestFor: "Digital, CRM, CX, Strategy, Client Service",
        why: "Senior marketing, digital, CX, and customer-data leader audience.",
        registrationUrl: "https://themartechsummit.com/bangkok/",
        type: "Marketing / digital",
    },
    {
        id: "digital-marketing-asia-malaysia-2026",
        priority: "A",
        market: "Malaysia",
        title: "Digital Marketing Asia Malaysia 2026",
        start: "2026-10-07",
        end: "2026-10-07",
        location: "Hilton Kuala Lumpur",
        category: "Digital marketing, AI, commerce, data",
        organiser: "MARKETING-INTERACTIVE",
        bestFor: "Malaysia leadership, Digital, Media, Strategy",
        why: "Direct fit for Malaysian marketing decision makers; part of the regional DMA footprint.",
        registrationUrl: "https://conferences.marketing-interactive.com/digital-marketing-my/",
        type: "Marketing / digital",
    },
    {
        id: "digital-marketing-asia-indonesia-2026",
        priority: "A",
        market: "Jakarta",
        title: "Digital Marketing Asia Indonesia 2026",
        start: "2026-10-13",
        end: "2026-10-13",
        location: "Jakarta",
        category: "Digital marketing, AI, commerce, data",
        organiser: "MARKETING-INTERACTIVE",
        bestFor: "Indonesia leadership, Digital, Media, Strategy",
        why: "Direct fit for senior marketers and digital decision makers in Indonesia.",
        registrationUrl: "https://conferences.marketing-interactive.com/digital-marketing-id/",
        type: "Marketing / digital",
    },
    {
        id: "b2b-marketing-leaders-forum-asia-2026",
        priority: "A",
        market: "Singapore",
        title: "B2B Marketing Leaders Forum Asia 2026",
        start: "2026-10-14",
        end: "2026-10-15",
        location: "PARKROYAL COLLECTION Pickering, Singapore",
        category: "B2B marketing, revenue, pipeline, AI",
        organiser: "B2B Marketing Leaders Forum",
        bestFor: "Business Development, Strategy, Client Service, Digital",
        why: "Very strong fit for pipeline, growth, CMO, and B2B marketing decision makers across Asia.",
        registrationUrl: "https://b2bmarketingleaders.com.au/singapore/",
        type: "Marketing / digital",
    },
    {
        id: "digicon-2026",
        priority: "A",
        market: "Manila",
        title: "DigiCon 2026: Interoperability",
        start: "2026-10-15",
        end: "2026-10-16",
        location: "Manila Marriott Hotel, Grand Ballroom",
        category: "Digital marketing, AI, media, tech, creative",
        organiser: "DigiCon",
        bestFor: "Philippines leadership, Digital, Creative, Media, Strategy",
        why: "Premier Philippines digital marketing gathering for marketers, tech leaders, media, data, brand, and creative sectors.",
        registrationUrl: "https://campaignbriefasia.com/2026/03/04/digicon-2026-returns-with-theme-interoperability-welcome-to-the-age-of-collaboration/",
        type: "Marketing / digital",
    },
    {
        id: "digital-marketing-asia-hong-kong-2026",
        priority: "A",
        market: "Hong Kong",
        title: "Digital Marketing Asia Hong Kong 2026",
        start: "2026-10-21",
        end: "2026-10-22",
        location: "Hong Kong",
        category: "Digital marketing, AI, commerce, data",
        organiser: "MARKETING-INTERACTIVE",
        bestFor: "Hong Kong leadership, Digital, Media, Strategy",
        why: "Direct fit for Hong Kong marketing and digital leaders; part of the regional DMA footprint.",
        registrationUrl: "https://conferences.marketing-interactive.com/digital-marketing-hk/",
        type: "Marketing / digital",
    },
    {
        id: "whats-next-marketing-malaysia-2026",
        priority: "A",
        market: "Malaysia",
        title: "What's NEXT in Marketing: Malaysia 2026",
        start: "2026-10-22",
        end: "2026-10-22",
        location: "Sheraton Petaling Jaya",
        category: "Marketing, AI, digital, customer engagement",
        organiser: "MARKETECH APAC",
        bestFor: "Malaysia leadership, Digital, Performance, Strategy",
        why: "Malaysia-specific event for AI, customer engagement, digital marketing, and decision-maker networking.",
        registrationUrl: "https://marketech-apac.com/conference/whats-next-in-marketing-malaysia-2026/",
        type: "Marketing / digital",
    },
    {
        id: "asian-media-leaders-summit-2026",
        priority: "A",
        market: "Singapore",
        title: "Asian Media Leaders Summit 2026",
        start: "2026-10-26",
        end: "2026-10-27",
        location: "Singapore",
        category: "Publisher, news media, media owners, advertising",
        organiser: "WAN-IFRA",
        bestFor: "Media, Publishers, Partnerships, Business Development",
        why: "High-value publisher and news-media leadership event with CEOs, CMOs, CROs, media owners, publishers, newsroom leaders, technology providers, and advertising partners.",
        registrationUrl: "https://wan-ifra.org/events/amls-2026/",
        type: "Publisher / media",
    },
    {
        id: "hong-kong-fintech-week-startmeuphk-2026",
        priority: "B",
        market: "Hong Kong",
        title: "Hong Kong FinTech Week x StartmeupHK 2026",
        start: "2026-11-02",
        end: "2026-11-06",
        location: "HKCEC and multiple venues",
        category: "AI, fintech, startups, digital innovation",
        organiser: "InvestHK",
        bestFor: "Hong Kong leadership, Business Development, Digital, Innovation",
        why: "Large tech/startup event with leaders across fintech, innovation, and startup ecosystems.",
        registrationUrl: "https://www.investhk.gov.hk/en/events/hong-kong-fintech-week-x-startmeuphk-2026/",
        type: "Technology / AI",
    },
    {
        id: "whats-next-marketing-hong-kong-2026",
        priority: "A",
        market: "Hong Kong",
        title: "What's NEXT in Marketing: Hong Kong 2026",
        start: "2026-11-12",
        end: "2026-11-12",
        location: "Cordis, Hong Kong",
        category: "Marketing, AI, fintech marketing, digital",
        organiser: "MARKETECH APAC",
        bestFor: "Hong Kong leadership, Digital, Strategy, Client Service",
        why: "Hong Kong-specific marketing event with AI, fintech marketing, customer value, and elite networking.",
        registrationUrl: "https://marketech-apac.com/conference/whats-next-in-marketing-hong-kong-2026/",
        type: "Marketing / digital",
    },
    {
        id: "smart-nation-expo-2026",
        priority: "B",
        market: "Malaysia",
        title: "Smart Nation Expo 2026",
        start: "2026-11-17",
        end: "2026-11-19",
        location: "MITEC, Kuala Lumpur",
        category: "Digital economy, AI, smart cities, tech",
        organiser: "Smart Nation Expo",
        bestFor: "Technology, Digital, Business Development",
        why: "Useful for digital economy, technology, and enterprise innovation leads in Malaysia.",
        registrationUrl: "https://www.smartnationexpo.org/visit-us/",
        type: "Technology / AI",
    },
    {
        id: "smarties-apac-2026",
        priority: "A",
        market: "Singapore",
        title: "SMARTIES APAC Celebration of Marketing Excellence 2026",
        start: "2026-11-20",
        end: "2026-11-20",
        location: "JW Marriott Singapore",
        category: "Marketing, media, adtech, martech, awards",
        organiser: "MMA / Marketing + Media Alliance",
        bestFor: "Media, Digital, Strategy, Business Development",
        why: "Strong marketing, media, adtech, martech, and business-impact awards event with regional brand, agency, and platform attendance.",
        registrationUrl: "https://mmaglobal.com/smarties/awards/programs/apac/gala",
        type: "Industry body / publisher",
    },
    {
        id: "asia-tv-forum-market-2026",
        priority: "A",
        market: "Singapore",
        title: "Asia TV Forum & Market 2026",
        start: "2026-12-01",
        end: "2026-12-04",
        location: "Marina Bay Sands, Singapore",
        category: "TV, streaming, entertainment, content, media business",
        organiser: "RX / ATF",
        bestFor: "Media, Content, Partnerships, Business Development",
        why: "Major TV, streaming, entertainment, content, distribution, and media-business marketplace at Marina Bay Sands.",
        registrationUrl: "https://www.asiatvforum.com/",
        type: "Publisher / media",
    },
    {
        id: "avia-dialogue-singapore-2026",
        priority: "B",
        market: "Singapore",
        title: "AVIA Dialogue - Singapore and AVIA Industry Drinks 2026",
        start: "2026-12-03",
        end: "2026-12-03",
        location: "Singapore",
        category: "Video, streaming, content, broadcaster, media technology",
        organiser: "Asia Video Industry Association",
        bestFor: "Media, Content, Partnerships, Technology",
        why: "Useful networking with video, streaming, content, broadcaster, and media technology leaders.",
        registrationUrl: "https://avia.org/events/",
        type: "Publisher / media",
    },
    {
        id: "affiliate-world-asia-2026",
        priority: "A",
        market: "Bangkok",
        title: "Affiliate World Asia 2026",
        start: "2026-12-09",
        end: "2026-12-10",
        location: "Bangkok",
        category: "Performance marketing, affiliate, ecommerce, AI ads",
        organiser: "Affiliate World",
        bestFor: "Performance, Media, Ecommerce, Business Development",
        why: "Major performance and affiliate marketing event with ecommerce, adtech, and AI advertising tracks.",
        registrationUrl: "https://affiliateworldconferences.com/asia",
        type: "Marketing / digital",
    },
    {
        id: "citra-pariwara-38",
        priority: "A",
        market: "Indonesia",
        title: "Citra Pariwara 38",
        start: "2026-12-10",
        end: "2026-12-11",
        location: "Indonesia",
        category: "Advertising, media, digital creative festival",
        organiser: "P3I / Citra Pariwara",
        bestFor: "Indonesia leadership, Creative, Media, Strategy",
        why: "Indonesia advertising, media, and digital creative festival; strong local agency and creative industry fit.",
        registrationUrl: "https://citrapariwara.org/",
        type: "Industry body / publisher",
    },
    {
        id: "martech-summit-asia-2027",
        priority: "A",
        market: "Singapore",
        title: "The MarTech Summit Asia 2027",
        start: "2027-03-02",
        end: "2027-03-03",
        location: "Raffles City Convention Centre, Singapore",
        category: "Martech, analytics, CX, AI, full-funnel marketing",
        organiser: "The MarTech Summit",
        bestFor: "Digital, CRM, Data, Strategy, Client Service",
        why: "APAC flagship martech event; good early-planning item for 2027.",
        registrationUrl: "https://themartechsummit.com/singapore/",
        type: "Marketing / digital",
    },
];

export const FINANCE_UPDATE_EVENTS = [
    {
        id: "iras-eis-ai-rd-foreign-subsidiary-2026",
        priority: "A",
        market: "Online",
        marketScope: ["Singapore"],
        title: "IRAS Enterprise Innovation Scheme: R&D and AI expenditure update",
        start: "2026-07-14",
        end: "2026-07-14",
        dateLabel: "Budget 2026 update",
        location: "Online",
        category: "R&D, AI expenditure, tax deductions, foreign-owned entities",
        organiser: "IRAS",
        bestFor: "Finance, Management, Tax, Operations",
        why: "Current government source for R&D, innovation, training, IP, and AI expenditure tax deductions, including eligibility for registered branches and subsidiaries of foreign parents.",
        registrationUrl: "https://www.iras.gov.sg/schemes/disbursement-schemes/enterprise-innovation-scheme-%28eis%29",
        type: "Government update",
        ctaLabel: "View update",
    },
    {
        id: "xero-analytics-training-july-2026",
        priority: "B",
        market: "Online",
        title: "Xero Analytics live training",
        start: "2026-07-14",
        end: "2026-07-14",
        location: "Online",
        category: "Xero, reporting, analytics, finance automation",
        organiser: "Xero",
        bestFor: "Finance, Reporting, Management",
        why: "Practical Xero session for finance visibility, reporting, analytics, and recurring product training updates.",
        registrationUrl: "https://learning.central.xero.com/student/all_sessions",
        type: "Xero / online training",
        ctaLabel: "Enroll",
    },
    {
        id: "xero-practice-workflows-app-stack-july-2026",
        priority: "B",
        market: "Online",
        title: "Xero workflow and app-stack automation session",
        start: "2026-07-20",
        end: "2026-07-20",
        location: "Online",
        category: "Xero, workflow automation, app stack, finance operations",
        organiser: "Xero",
        bestFor: "Finance, Operations, Process Improvement",
        why: "Useful for keeping finance workflows current as Xero releases new automation, app-stack, and practice productivity updates.",
        registrationUrl: "https://learning.central.xero.com/student/all_sessions",
        type: "Xero / online training",
        ctaLabel: "Enroll",
    },
    {
        id: "finance-transformation-summit-singapore-2026",
        priority: "A",
        market: "Singapore",
        title: "Finance Transformation Summit Singapore 2026",
        start: "2026-07-29",
        end: "2026-07-29",
        location: "Marina Bay Sands, Singapore",
        category: "Finance transformation, AI, automation, reporting, controls",
        organiser: "Forefront Events",
        bestFor: "Finance, Management, Reporting, Operations",
        why: "CFO and senior finance audience focused on AI adoption, automation, reporting accuracy, controls, and finance transformation.",
        registrationUrl: "https://forefrontevents.co/event/finance-transformation-summit-singapore-2026",
        type: "Finance / AI",
    },
    {
        id: "xero-awards-asia-2026",
        priority: "B",
        market: "Singapore",
        title: "Xero Awards Asia 2026",
        start: "2026-08-06",
        end: "2026-08-06",
        location: "Singapore",
        category: "Xero ecosystem, accounting partners, finance technology",
        organiser: "Xero",
        bestFor: "Finance, Management, Accounting Partners",
        why: "Regional Xero ecosystem gathering in Singapore, useful for spotting accounting partners, Xero implementation partners, and product-led finance trends.",
        registrationUrl: "https://www.xero.com/events/xero-awards/asia-2026/",
        type: "Xero / ecosystem",
    },
    {
        id: "cfo-finance-leaders-summit-singapore-2026",
        priority: "A",
        market: "Singapore",
        title: "CFO & Finance Leaders' Summit Singapore 2026",
        start: "2026-08-18",
        end: "2026-08-18",
        location: "Singapore",
        category: "CFO, AI, ESG, finance leadership, risk",
        organiser: "Fortinus Events",
        bestFor: "Finance, Management, Strategy",
        why: "Senior finance leadership event with AI, talent, board expectations, ESG, finance resilience, and cross-functional CFO/CHRO networking.",
        registrationUrl: "https://events.fortinusevents.com/CFOSG26",
        type: "Finance / leadership",
    },
    {
        id: "transfer-pricing-singapore-2026",
        priority: "A",
        market: "Online",
        marketScope: ["Singapore"],
        title: "Transfer Pricing in Singapore 2026",
        start: "2026-08-20",
        end: "2026-08-20",
        location: "Online",
        category: "Transfer pricing, intercompany billing, related-party transactions",
        organiser: "Transfer Pricing Solutions Asia",
        bestFor: "Finance, Tax, Management",
        why: "Practical webinar for intercompany billing, related-party transactions, documentation, IRAS expectations, and year-end compliance planning.",
        registrationUrl: "https://www.transferpricingsolutions.asia/en/events/transfer-pricing-in-singapore-2026/",
        type: "Tax / intercompany billing",
    },
    {
        id: "c-engage-convention-2026",
        priority: "B",
        market: "Singapore",
        title: "C-Engage Convention 2026",
        start: "2026-09-17",
        end: "2026-09-17",
        location: "Marina Bay Sands, Singapore",
        category: "CFO, CIO, AI, technology investment, finance leadership",
        organiser: "C-Engage",
        bestFor: "Finance, Management, Technology",
        why: "Singapore CFO/CIO conference covering AI, technology investment, and finance-technology partnership decisions.",
        registrationUrl: "https://c-engage.com/",
        type: "Finance / AI",
    },
    {
        id: "apac-finance-forum-2026",
        priority: "B",
        market: "Singapore",
        title: "APAC Finance Forum 2026",
        start: "2026-09-23",
        end: "2026-09-23",
        location: "Singapore",
        category: "Finance infrastructure, digital assets, investment, regional finance",
        organiser: "The Tech Capital",
        bestFor: "Finance, Management, Strategy",
        why: "Regional finance forum for finance infrastructure, data, capital, investment, and strategic finance conversations.",
        registrationUrl: "https://events.thetechcapital.com/page/apac-finance-forum-2026",
        type: "Finance / regional",
    },
    {
        id: "accounting-business-show-asia-2026",
        priority: "A",
        market: "Singapore",
        title: "Accounting & Business Show Asia 2026",
        start: "2026-10-13",
        end: "2026-10-14",
        location: "Sands Expo & Convention Centre, Singapore",
        category: "Accounting, finance technology, automation, payroll, ERP",
        organiser: "Terrapinn",
        bestFor: "Finance, Payroll, Operations, Management",
        why: "Large accounting and finance technology event for software, automation, payroll, ERP, reporting, and finance operations suppliers.",
        registrationUrl: "https://form.jotform.com/252658474083465",
        type: "Accounting / finance technology",
    },
    {
        id: "ai-financial-services-singapore-2026",
        priority: "A",
        market: "Singapore",
        title: "AI in Financial Services Singapore 2026",
        start: "2026-11-05",
        end: "2026-11-05",
        location: "Marina Bay Sands, Singapore",
        category: "AI, finance, risk, governance, financial services",
        organiser: "Arena International",
        bestFor: "Finance, Management, Risk, Technology",
        why: "Focused AI-in-finance event for enterprise adoption, governance, operational risk, and finance-sector AI implementation lessons.",
        registrationUrl: "https://www.arena-international.com/event/aifs-asiapacific/",
        type: "Finance / AI",
    },
    {
        id: "accounting-einvoicing-malaysia-webinar-2026",
        priority: "A",
        market: "Malaysia",
        title: "Accounting and e-Invoicing in Malaysia - Webinar 2026",
        start: "2026-11-13",
        end: "2026-11-13",
        location: "Online",
        category: "Malaysia e-invoicing, IRBM, accounting compliance",
        organiser: "CPA Australia",
        bestFor: "Finance, Malaysia Management, Tax",
        why: "Malaysia compliance training for accounting framework, financial statements, MyInvois, IRBM e-invoicing, and implementation requirements.",
        registrationUrl: "https://www.cpaaustralia.com.au/professional-development/courses-and-events/accounting-and-e-invoicing-in-malaysia-webinar-2026",
        type: "Tax / e-invoicing",
    },
];

export const HR_UPDATE_EVENTS = [
    {
        id: "wsg-career-conversion-employer-update-2026",
        priority: "A",
        market: "Online",
        marketScope: ["Singapore"],
        title: "WSG Career Conversion Programmes for Employers",
        start: "2026-07-14",
        end: "2026-07-14",
        dateLabel: "Rolling update",
        location: "Online",
        category: "Hiring support, salary support, reskilling, job redesign",
        organiser: "Workforce Singapore",
        bestFor: "HR, Management, Hiring Managers",
        why: "Government source for salary support and reskilling programmes that can support hiring or role conversion for Singapore citizens and PRs.",
        registrationUrl: "https://www.wsg.gov.sg/programmes-and-initiatives/career-conversion-programmes-employers.html",
        type: "Government update",
        ctaLabel: "View update",
    },
    {
        id: "skillsfuture-employer-training-funding-2026",
        priority: "A",
        market: "Online",
        marketScope: ["Singapore"],
        title: "SkillsFuture employer training grants and subsidies",
        start: "2026-07-14",
        end: "2026-07-14",
        dateLabel: "Rolling update",
        location: "Online",
        category: "Training grants, upskilling, workforce capability",
        organiser: "SkillsFuture Singapore",
        bestFor: "HR, Management, Department Heads",
        why: "Government source for employer training funding, useful when planning internal upskilling, AI training, and workforce capability programmes.",
        registrationUrl: "https://www.skillsfuture.gov.sg/funding-employers",
        type: "Government update",
        ctaLabel: "View update",
    },
    {
        id: "pmap-hr-analytics-july-2026",
        priority: "B",
        market: "Manila",
        title: "HR Analytics and Data-Driven Decision Making",
        start: "2026-07-16",
        end: "2026-07-17",
        location: "PMAP Center, Mandaluyong City",
        category: "HR analytics, data, workforce decisions",
        organiser: "People Management Association of the Philippines",
        bestFor: "HR, People Analytics, Management",
        why: "Hands-on HR analytics training for data-driven people decisions, workforce reporting, and HR planning.",
        registrationUrl: "https://pmap.org.ph/training-events/hrddm-july/",
        type: "HR training",
    },
    {
        id: "malaysia-hr-forum-labour-ordinance-july-2026",
        priority: "A",
        market: "Online",
        marketScope: ["Malaysia"],
        title: "Sabah & Sarawak Labour Ordinance Amendments 2025",
        start: "2026-07-20",
        end: "2026-07-20",
        location: "Online",
        category: "Malaysia labour law, HR compliance, employment rules",
        organiser: "Malaysia HR Forum",
        bestFor: "HR, Malaysia Management, Compliance",
        why: "Free compliance webinar on Sabah and Sarawak labour ordinance amendments and practical HR implications for employers.",
        registrationUrl: "https://malaysiahrforum.com/catalogue/150-free-webinar-sabah-sarawak-labour-ordinance-amendments-2025/",
        type: "HR / regulation",
    },
    {
        id: "pmap-hr-statistics-july-2026",
        priority: "B",
        market: "Online",
        marketScope: ["Manila", "Philippines"],
        title: "Data Visualization and Statistical Analysis for HR Statistics",
        start: "2026-07-21",
        end: "2026-07-24",
        location: "Virtual",
        category: "HR statistics, analytics, data visualization",
        organiser: "People Management Association of the Philippines",
        bestFor: "HR, People Analytics, Management",
        why: "HR statistics course for stronger workforce reporting, dashboards, people metrics, and evidence-based planning.",
        registrationUrl: "https://pmap.org.ph/training-events/schrmb1/",
        type: "HR training",
    },
    {
        id: "hkihrm-ai-hr-operations-2026",
        priority: "B",
        market: "Hong Kong",
        title: "Certificate in AI-Powered HR Operations & Automation",
        start: "2026-07-28",
        end: "2026-07-28",
        location: "HKIHRM premises, Hong Kong",
        category: "AI, HR operations, automation",
        organiser: "HKIHRM",
        bestFor: "HR, Operations, Management",
        why: "AI-focused HR operations session for automation opportunities, policy guardrails, and practical HR team productivity.",
        registrationUrl: "https://growthacademyasia.com/events/",
        type: "HR / AI",
    },
    {
        id: "chro-hr-leaders-singapore-2026",
        priority: "A",
        market: "Singapore",
        title: "CHRO & HR Leaders' Summit Singapore 2026",
        start: "2026-08-18",
        end: "2026-08-18",
        location: "Singapore",
        category: "HR leadership, workforce strategy, AI, finance collaboration",
        organiser: "Fortinus Events",
        bestFor: "HR, Management, Department Heads",
        why: "Senior HR leadership summit co-located with the CFO summit, useful for workforce planning, HR-finance alignment, and AI-in-HR discussions.",
        registrationUrl: "https://growthacademyasia.com/event/chro-hr-leaders-summit-singapore-2026/",
        type: "HR leadership",
    },
    {
        id: "hr-worktech-thailand-2026",
        priority: "A",
        market: "Bangkok",
        title: "HR Worktech Summit Thailand 2026",
        start: "2026-08-20",
        end: "2026-08-20",
        location: "Golden Tulip Sovereign Hotel Bangkok",
        category: "HR technology, AI, employee experience, future of work",
        organiser: "Growth Academy Asia",
        bestFor: "HR, Technology, Management",
        why: "Thailand HR technology event for AI, HR operations, employee experience, and future-of-work trends.",
        registrationUrl: "https://growthacademyasia.com/events/",
        type: "HR / AI",
    },
    {
        id: "chro-hr-leaders-indonesia-2026",
        priority: "A",
        market: "Jakarta",
        title: "CHRO & HR Leaders' Summit Indonesia 2026",
        start: "2026-08-27",
        end: "2026-08-27",
        location: "Jakarta",
        category: "HR leadership, AI, workforce strategy",
        organiser: "Fortinus Events",
        bestFor: "HR, Indonesia Management, Department Heads",
        why: "Senior Indonesia HR leadership event on the 2026 HR landscape, workforce strategy, and CHRO priorities.",
        registrationUrl: "https://events.fortinusevents.com/CHROINDONESIA26",
        type: "HR leadership",
    },
    {
        id: "mercer-asia-hr-conference-2026",
        priority: "A",
        market: "Singapore",
        title: "Mercer Asia HR Conference 2026",
        start: "2026-09-01",
        end: "2026-09-02",
        location: "Pan Pacific Singapore",
        category: "Rewards, talent, workforce strategy, HR transformation",
        organiser: "Mercer",
        bestFor: "HR, Management, Rewards",
        why: "Regional HR leadership conference for rewards, talent strategy, workforce planning, and people transformation.",
        registrationUrl: "https://growthacademyasia.com/events/",
        type: "HR conference",
    },
    {
        id: "malaysia-hr-tech-innovation-2026",
        priority: "A",
        market: "Malaysia",
        title: "Malaysia HR Tech & Innovation Conference & Expo 2026",
        start: "2026-09-22",
        end: "2026-09-23",
        location: "Connexion Conference & Event Centre, Kuala Lumpur",
        category: "HR technology, AI, innovation, people operations",
        organiser: "Growth Academy Asia",
        bestFor: "HR, Malaysia Management, Operations",
        why: "Malaysia HR technology and innovation event for AI, people systems, HR operations, and vendor discovery.",
        registrationUrl: "https://growthacademyasia.com/events/",
        type: "HR / AI",
    },
    {
        id: "chro-series-singapore-2026",
        priority: "A",
        market: "Singapore",
        title: "CHRO Series Singapore 2026",
        start: "2026-10-06",
        end: "2026-10-08",
        location: "One Farrer Hotel, Singapore",
        category: "HR leadership, talent, employee experience, AI",
        organiser: "CHRO Series",
        bestFor: "HR, Management, Department Heads",
        why: "Singapore CHRO programme for senior HR leaders and management teams planning talent, culture, AI, and workforce transformation.",
        registrationUrl: "https://chroseries.com/country/singapore/",
        type: "HR leadership",
    },
    {
        id: "future-of-work-apac-2026",
        priority: "A",
        market: "Singapore",
        title: "Future of Work APAC 2026",
        start: "2026-11-18",
        end: "2026-11-19",
        location: "Marina Bay Sands, Singapore",
        category: "Future of work, AI, HR technology, workforce transformation",
        organiser: "Future Work Series",
        bestFor: "HR, Management, Technology",
        why: "APAC future-of-work conference for AI, HR technology, workplace transformation, and people strategy.",
        registrationUrl: "https://futureworkseries.com/apac-2026",
        type: "HR / AI",
    },
    {
        id: "hr-worktech-indonesia-2026",
        priority: "A",
        market: "Jakarta",
        title: "HR Worktech Summit Indonesia 2026",
        start: "2026-11-19",
        end: "2026-11-19",
        location: "Jakarta Convention Center",
        category: "HR technology, AI, employee experience, future of work",
        organiser: "Growth Academy Asia",
        bestFor: "HR, Indonesia Management, Technology",
        why: "Indonesia HR technology summit for digital HR transformation, employee experience, AI, and future-focused talent management.",
        registrationUrl: "https://growthacademyasia.com/event/annual-hr-worktech-summit/",
        type: "HR / AI",
    },
];

export const ALL_EVENT_STREAM_EVENTS = [
    ...NETWORKING_EVENTS,
    ...FINANCE_UPDATE_EVENTS,
    ...HR_UPDATE_EVENTS,
];

const parseDate = (value) => new Date(`${value}T00:00:00`);

const isSameDate = (left, right) =>
    left.getFullYear() === right.getFullYear() &&
    left.getMonth() === right.getMonth() &&
    left.getDate() === right.getDate();

const isSameMonth = (left, right) =>
    left.getFullYear() === right.getFullYear() && left.getMonth() === right.getMonth();

export const formatNetworkingEventDateRange = (event) => {
    if (event?.dateLabel) return event.dateLabel;

    const startDate = parseDate(event.start);
    const endDate = parseDate(event.end || event.start);

    if (isSameDate(startDate, endDate)) {
        return DATE_FORMATTER.format(startDate);
    }

    if (isSameMonth(startDate, endDate)) {
        return `${startDate.getDate()}-${DATE_FORMATTER.format(endDate)}`;
    }

    return `${DAY_MONTH_FORMATTER.format(startDate)}-${DATE_FORMATTER.format(endDate)}`;
};

export const formatNetworkingEventMonth = (event) =>
    MONTH_YEAR_FORMATTER.format(parseDate(event.start));

const COUNTRY_MARKET_GROUPS = [
    { aliases: ["singapore", "sg"], markets: ["Singapore"] },
    { aliases: ["malaysia", "my", "kuala lumpur"], markets: ["Malaysia", "Kuala Lumpur"] },
    { aliases: ["indonesia", "id", "jakarta", "bali"], markets: ["Jakarta", "Bali", "Indonesia"] },
    { aliases: ["thailand", "th", "bangkok"], markets: ["Bangkok", "Thailand"] },
    { aliases: ["philippines", "ph", "manila"], markets: ["Manila", "Philippines"] },
    { aliases: ["hong kong", "hk"], markets: ["Hong Kong"] },
];

const normalizeMarketValue = (value) =>
    String(value || "")
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, " ")
        .trim();

export const getNetworkingEventMarketsForCountry = (country) => {
    const normalizedCountry = normalizeMarketValue(country);
    if (!normalizedCountry) return null;

    return COUNTRY_MARKET_GROUPS.find((group) =>
        group.aliases.some((alias) => normalizeMarketValue(alias) === normalizedCountry)
    )?.markets || null;
};

const CROSS_MARKET_VALUES = new Set(["online", "regional", "global", "apac"]);

const isCrossMarketEvent = (event) =>
    event?.isRegional === true || (!Array.isArray(event?.marketScope) && CROSS_MARKET_VALUES.has(normalizeMarketValue(event?.market)));

const getEventFilterMarkets = (event) => [
    event?.market,
    ...(Array.isArray(event?.marketScope) ? event.marketScope : []),
];

const getUpcomingEventsFromSource = (events, {
    fromDate = new Date(),
    limit = 3,
    priorities = ["A", "B"],
    country = null,
    markets = null,
    includeCrossMarket = false,
} = {}) => {
    const dayStart = new Date(fromDate);
    dayStart.setHours(0, 0, 0, 0);
    const countryMarkets = country ? getNetworkingEventMarketsForCountry(country) : null;
    const activeMarkets = Array.isArray(markets) ? markets : countryMarkets;
    const marketSet = Array.isArray(activeMarkets) && activeMarkets.length
        ? new Set(activeMarkets.map(normalizeMarketValue))
        : null;

    return events
        .filter((event) => priorities.includes(event.priority))
        .filter((event) =>
            !marketSet ||
            getEventFilterMarkets(event).some((market) => marketSet.has(normalizeMarketValue(market))) ||
            (includeCrossMarket && isCrossMarketEvent(event))
        )
        .filter((event) => parseDate(event.end || event.start) >= dayStart)
        .sort((left, right) => parseDate(left.start) - parseDate(right.start))
        .slice(0, limit);
};

export const getUpcomingNetworkingEvents = (options = {}) =>
    getUpcomingEventsFromSource(NETWORKING_EVENTS, options);

export const getUpcomingFinanceUpdateEvents = (options = {}) =>
    getUpcomingEventsFromSource(FINANCE_UPDATE_EVENTS, { includeCrossMarket: true, ...options });

export const getUpcomingHrUpdateEvents = (options = {}) =>
    getUpcomingEventsFromSource(HR_UPDATE_EVENTS, { includeCrossMarket: true, ...options });

export const EVENT_CALENDAR_STREAMS = [
    {
        key: "marketing",
        label: "Marketing",
        heading: "Upcoming networking events",
        tableTitle: "Marketing event list",
        description: "Marketing, media, digital, agency, advertising, publisher, adtech, martech, and AI events for lead generation.",
        events: NETWORKING_EVENTS,
        getUpcomingEvents: getUpcomingNetworkingEvents,
    },
    {
        key: "all",
        label: "All",
        heading: "Upcoming marketing, finance and HR events",
        tableTitle: "All event list",
        description: "Combined marketing, finance, HR, AI, government, training, and networking updates for management planning.",
        events: ALL_EVENT_STREAM_EVENTS,
        getUpcomingEvents: (options = {}) => getUpcomingEventsFromSource(ALL_EVENT_STREAM_EVENTS, options),
    },
    {
        key: "finance",
        label: "Finance",
        heading: "Upcoming finance updates",
        tableTitle: "Finance update list",
        description: "Finance events, AI finance sessions, Xero trainings, tax updates, R&D support, intercompany billing, and government sources.",
        events: FINANCE_UPDATE_EVENTS,
        getUpcomingEvents: getUpcomingFinanceUpdateEvents,
    },
    {
        key: "hr",
        label: "HR",
        heading: "Upcoming HR updates",
        tableTitle: "HR update list",
        description: "HR events, hiring support, training grants, labour-law updates, recruitment, AI in HR, and future-of-work sessions.",
        events: HR_UPDATE_EVENTS,
        getUpcomingEvents: getUpcomingHrUpdateEvents,
    },
];

export const getEventCalendarStream = (key = "marketing") =>
    EVENT_CALENDAR_STREAMS.find((stream) => stream.key === key) ||
    EVENT_CALENDAR_STREAMS.find((stream) => stream.key === "marketing") ||
    EVENT_CALENDAR_STREAMS[0];

export const getNetworkingCalendarEvents = (events = NETWORKING_EVENTS) =>
    events.map((event) => ({
        id: event.id,
        title: event.title,
        start: event.start,
        end: event.end,
        allDay: true,
        color: event.priority === "A" ? "#1b1b1b" : event.priority === "B" ? "#f0b429" : "#8a8a8a",
        textColor: event.priority === "B" ? "#1b1b1b" : "#ffffff",
        className: `networking-event networking-event-priority-${event.priority.toLowerCase()}`,
        extendedProps: {
            ...event,
        },
    }));
